// src/modules/app-views/invoices/components/InvoicesDocumentCardHeaderColumn3.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import {
  FileProtectOutlined,
  IdcardOutlined,
  SafetyCertificateOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import translateX from 'utils/translateX';
import useZustand from 'hooks/useZustand';
import appService from 'services/appService';
import { parseCnpjToDisplay, parseIeToDisplay } from 'utils/helpers';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const CardHeaderInvoiceIssuerCnpjIe = ({
  showItem1 = true,
  showItem2 = true,
  showItem3 = true,
  forceShow = false,
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const storedCompany = useZustand('auth', 'company');
  const storedCompanies = useZustand('auth', 'companies');

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const issuerName = storedCompany?.razaoSocial || storedCompany?.fullName || storedCompany?.name;
  const issuerCnpj = storedCompany?.cnpj?.value && parseCnpjToDisplay(storedCompany.cnpj.value);
  const issuerUf = storedCompany?.address?.region;
  const rawIe = storedCompany?.fiscalData?.stateRegistration || storedCompany?.ie;
  const issuerIe = rawIe && parseIeToDisplay(rawIe, issuerUf);

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleChangeEmissor = () => {
    console.log('change issuer');
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'issuerName',
      icon: <ShopOutlined />,
      label: (
        <span className="text-uppercase">
          {issuerName || <span className="text-muted opacity-0-6">{translateX('issuer')}</span>}
        </span>
      ),
      tooltipText: translateX(storedCompanies?.length > 1 ? 'change_issuer' : 'issuer'),
      tooltipPlacement: 'right',
      onClick: storedCompanies?.length > 1 ? handleChangeEmissor : null,
      hidden: !showItem1,
    },
    {
      key: 'issuerCnpj',
      icon: <FileProtectOutlined />,
      label: issuerCnpj || <span className="text-muted opacity-0-6">{translateX('cnpj')}</span>,
      tooltipText: translateX('cnpj'),
      tooltipPlacement: 'right',
      onClick: () => appService.handleCopyToClipboard(issuerCnpj, 'cnpj_copied'),
      hidden: !showItem2,
    },
    {
      key: 'issuerIe',
      icon: <SafetyCertificateOutlined />,
      label: issuerIe || (
        <span className="text-muted opacity-0-6">{translateX('state_registration')}</span>
      ),
      tooltipText: translateX('state_registration'),
      tooltipPlacement: 'right',
      onClick: () => appService.handleCopyToClipboard(issuerIe, 'ie_copied'),
      hidden: !showItem3,
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items?.filter(i => (i?.label || forceShow) && !i.hidden)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderInvoiceIssuerCnpjIe;

// *******************************************************************************
// HELPERS
// *******************************************************************************
